export default {
  floatingTopMenu: {
    openSettings: 'Settings',
    showAbout: 'Show general information',
    about: 'About ORS',
    openrouteserviceAPI: 'Openrouteservice API',
    openrouteserviceForDisasters: 'Openrouteservice for disasters',
    askOpenrouteservice: 'Ask openrouteservice',
    settingsTooltip: 'Click here if you want to adjust app settings and see other options'
  }
}
